import { FunctionComponent, useMemo } from "react";

import { LoadingOverlay } from "@/components";

import { useGetTrackerColumnByIdQuery } from "@/pages/Private/redux/profileTracker/profileTracker.api";

import { EditCustomColumnModal } from "./EditCustomColumnModal";
import { Tracker } from "../../../schema/profileTracker";

export interface EditCustomColumnModalWrapperProps {
	setOpen: (value: boolean) => void;
	open: boolean;
	trackerId: number;
	columnId: number;
	selectedTrackerOrganizationIds?: number[];
	tracker?: Tracker;
}

export const EditCustomColumnModalWrapper: FunctionComponent<EditCustomColumnModalWrapperProps> = ({
	open,
	setOpen,
	trackerId,
	columnId,
	selectedTrackerOrganizationIds,
	tracker,
}) => {
	const { data } = useGetTrackerColumnByIdQuery(columnId);

	const datWithoutId = useMemo(() => {
		if (data) {
			const { id, ...rest } = data;

			return rest;
		}
	}, [data]);

	return !datWithoutId ? (
		<LoadingOverlay />
	) : datWithoutId ? (
		<EditCustomColumnModal
			column={datWithoutId}
			columnId={columnId}
			open={open}
			selectedTrackerOrganizationIds={selectedTrackerOrganizationIds}
			setOpen={setOpen}
			tracker={tracker}
			trackerId={trackerId}
		/>
	) : (
		<></>
	);
};
